import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "infoPostModelSectionSelectionDv"
}
const _hoisted_2 = { class: "innerPostModelDv" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "StatsGridSectionSelectionDv topStats" }
const _hoisted_8 = { class: "StatsGridSectionSelectionDv favouriteInvestmentStat" }
const _hoisted_9 = { class: "StatsGridSectionSelectionDv portfolio" }
const _hoisted_10 = { class: "StatsGridSectionSelectionDv links" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _component_TopStatItemComponent = _resolveComponent("TopStatItemComponent")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_StockItemWidget = _resolveComponent("StockItemWidget")!
  const _component_PortfolioItem = _resolveComponent("PortfolioItem")!
  const _component_LinksItem = _resolveComponent("LinksItem")!

  return (_ctx.post && _ctx.post.sectionData)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.post.sectionData.name === 'Favorite Investments')
              ? (_openBlock(), _createElementBlock("h2", _hoisted_4, [
                  _createVNode(_component_IconComponent, {
                    class: "iconinfoLeftDv",
                    icon: "icon-section.svg"
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("common.common.favorite_symbols")), 1)
                ]))
              : (_openBlock(), _createElementBlock("h2", _hoisted_5, [
                  _createVNode(_component_IconComponent, {
                    class: "iconinfoLeftDv",
                    icon: "icon-section.svg"
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.post.sectionData.name), 1)
                ]))
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.post.sectionData.type === 'topStats')
              ? (_openBlock(), _createBlock(_component_el_scrollbar, { key: 0 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.post.sectionData.data, (stat) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "StastItemSectionSelectionDv",
                          key: stat
                        }, [
                          _createVNode(_component_TopStatItemComponent, {
                            fromPopup: true,
                            stat: stat,
                            fromOutside: _ctx.fromOutside
                          }, null, 8, ["stat", "fromOutside"])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.post.sectionData.type === 'favouriteInvestment')
              ? (_openBlock(), _createBlock(_component_el_scrollbar, { key: 1 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.post.sectionData.data, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "StastItemSectionSelectionDv",
                          key: item
                        }, [
                          (_openBlock(), _createBlock(_component_StockItemWidget, {
                            stockData: item,
                            key: item,
                            disableRouting: false
                          }, null, 8, ["stockData"]))
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.post.sectionData.type === 'portfolio')
              ? (_openBlock(), _createBlock(_component_el_scrollbar, { key: 2 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.post.sectionData.data, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "StastItemSectionSelectionDv",
                          key: item
                        }, [
                          _createVNode(_component_PortfolioItem, { portfolioData: item }, null, 8, ["portfolioData"])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.post.sectionData.type === 'links')
              ? (_openBlock(), _createBlock(_component_el_scrollbar, { key: 3 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.post.sectionData.data, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "StastItemSectionSelectionDv",
                          key: item
                        }, [
                          (_openBlock(), _createBlock(_component_LinksItem, {
                            class: "linkitemCardWidthDv",
                            trade: item,
                            key: item
                          }, null, 8, ["trade"]))
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}